import { useCallback, useReducer } from 'react';
import { rebuildPosicions } from '../../utils/loadPositions';

const loadingPositions = () => ({ caixes: {}, castellers: {}, loading: true });
const resolve = (value, previous) => typeof value === 'function' ? value(previous) : value;

function reducer(state, { type, value }) {
    if (type === 'log') {
        const posicionsLog = resolve(value, state.posicionsLog);
        if (posicionsLog === state.posicionsLog) return state;
        return {
            posicionsLog,
            posicions: posicionsLog === null ? loadingPositions() : rebuildPosicions({ posicionsLog }),
        };
    }
    // Loading and import previews can still override the displayed positions.
    return { ...state, posicions: resolve(value, state.posicions) };
}

export default function useBoardPositions() {
    const [state, dispatch] = useReducer(reducer, null, () => ({ posicionsLog: null, posicions: loadingPositions() }));
    const setPosicionsLog = useCallback(value => dispatch({ type: 'log', value }), []);
    const setPosicions = useCallback(value => dispatch({ type: 'positions', value }), []);
    // Keep the log and its derived positions in the same render, including ID promotion.
    return { ...state, setPosicionsLog, setPosicions };
}
